/**
 * AAA IDP Banner
 * 
 */
import * as React from 'react';
import './Banner.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Banner = props => {
  const {
    content,
    startApp,
    title
  } = props;
  return /*#__PURE__*/_jsxs("div", {
    className: "Banner",
    children: [/*#__PURE__*/_jsx("div", {
      className: "content",
      children: /*#__PURE__*/_jsxs("div", {
        className: "content-inner",
        children: [/*#__PURE__*/_jsx("h1", {
          children: title
        }), /*#__PURE__*/_jsx("p", {
          children: content
        }), /*#__PURE__*/_jsxs("div", {
          className: "banner-cta",
          children: [/*#__PURE__*/_jsx("a", {
            className: "button",
            role: "button",
            href: "#aaa-idp-start",
            onClick: startApp,
            children: "Start application"
          }), /*#__PURE__*/_jsx("a", {
            className: "button reverse",
            role: "button",
            href: "https://www.aaa.asn.au/international-motoring/international-driving-permits/",
            target: "_blank",
            rel: "noopener noreferrer",
            children: "Find out more"
          })]
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "image"
    })]
  });
};
Banner.defaultProps = {
  title: 'International Driving Permit',
  content: 'Your passport to driving overseas'
};
export default Banner;